import PropTypes from 'prop-types';
import { Col, Card, Tooltip } from 'antd';
import { DragOutlined } from '@ant-design/icons';

import AddFile from 'components/Icons/AddFile';

import '../ElementsMenu.scss';

function ElementMenuItem({
  title,
  type,
  icon,
  handleToolbarElements,
  setShowVariables,
  setScrollingTo,
  dragStart,
  dragEnd,
  showAttachmentModal,
  isWix,
}) {
  // no need or price and mile for wix
  if (['price', 'miles'].includes(type) && isWix) {
    return null;
  }

  const tooltip = (
    <Tooltip
      title={`Insert ${title}`}
      className="elements-menu-drag"
      overlayClassName="elements-menu-tooltip">
      <DragOutlined />
    </Tooltip>
  );

  if (type === 'attachment') {
    return (
      <Col span={12} id="add-attachment" onDragStart={dragStart} onDragEnd={dragEnd} draggable>
        {tooltip}
        <Card onClick={() => showAttachmentModal?.(true)}>
          <AddFile
            className="icon"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => handleToolbarElements(e, 'attachment')}
          />
          <span className="spacer" />
          <span className="text">Attach File</span>
        </Card>
      </Col>
    );
  } else if (type === 'variable') {
    return (
      <Col span={12} id="add-variable" onDragStart={dragStart} onDragEnd={dragEnd}>
        <Card
          onMouseDown={() => {
            setShowVariables(true);
            setScrollingTo('client');
          }}>
          {icon}
          <span className="spacer" />
          <span className="text">Variables</span>
        </Card>
      </Col>
    );
  }

  return (
    <Col
      span={12}
      className="drag-only-item"
      id={`add-${type}`}
      onDragStart={dragStart}
      onDragEnd={dragEnd}
      draggable>
      {tooltip}
      <Card onMouseDown={(e) => handleToolbarElements(e, type)}>
        {icon}
        <span className="spacer" />
        <span className="text">{title}</span>
      </Card>
    </Col>
  );
}

ElementMenuItem.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.node,
  handleToolbarElements: PropTypes.func,
  setShowVariables: PropTypes.func,
  setScrollingTo: PropTypes.func,
  dragStart: PropTypes.func,
  dragEnd: PropTypes.func,
  showAttachmentModal: PropTypes.func,
  isWix: PropTypes.bool,
};

export default ElementMenuItem;
